$(window).load(function() {
	var s = $(".details");
	var pos = $(".product-container").offset();
	var scrollmax;
	var alignRight;

	// Function to update alignRight and scrollmax
	function updateLayoutValues() {
		alignRight = ($(window).width() - $(".product-container").outerWidth()) / 2;
		scrollmax = $("#product2023").outerHeight() - s.outerHeight() + 100;
		s.css('right', alignRight);
	}

	// Adjust values on resize
	$(window).resize(function() {
		updateLayoutValues();
	});

	$(window).scroll(function() {
		var windowpos = $(window).scrollTop();
		var ww = $(window).width();

		if (ww > 960) {
			if (windowpos >= pos.top && windowpos <= scrollmax) {
				s.css('right', alignRight);
				s.addClass("stick").removeClass('max');
			} else if (windowpos >= scrollmax) {
				s.addClass("stick").addClass('max');
			} else {
				s.removeClass("stick max");
			}
		} else {
			s.removeClass("stick max");
		}
	});

	// Init
	updateLayoutValues();
});
